import { _ } from "../../polyglot/polyglot.js";
import { emptyArchiveIcon } from "../../elements/icons/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * Render a logo, a title and a subtitle in a large card. If actions
 * are provided, they are rendered below the subtitle.
 *
 * @param {Renderable} [logo] - Usually a picture to display on
 *   top of the title
 * @param {Renderable} [title] - Usually a short text to render
 *   big
 * @param {Renderable} [subtitle] - Usually a short text to
 *   render just below the title and a little smaller. Passing `null`
 *   to this parameter hides the subtitle whereas `undefined` renders
 *   a default one
 * @param {Renderable} [content] - A, possibly long, explanation
 * @param {Renderable} [actions] - Usually renderable actions to
 *   display, inviting the user to take first steps
 */
export default class EmptyArchiveWidget extends Widget {
	constructor({
		logo = emptyArchiveIcon,
		title = _("Empty archive"),
		subtitle = _("Let's get started!"),
		content = "",
		actions = [],
	}) {
		super(...arguments);

		this._actions = actions;
		this._title = title;
		this._subtitle = subtitle;
		this._content = content;
		this._logo = logo;
	}

	renderContentOn(html) {
		html.div(
			{
				"data-test": "empty-archive",
				klass: "empty-archive",
			},
			this._logo,
			html.h2(this._title),
			(html) => this._subtitle && html.h3(this._subtitle),
			this._content,
			html.div({ klass: "actions" }, this._actions),
		);
	}
}
